// extracted by mini-css-extract-plugin
module.exports = {"navbar":"styles_navbar__oqiUE","wrapper":"styles_wrapper__16jNS","logoContainer":"styles_logoContainer__2Ymr-","links":"styles_links__3Sp03","button":"styles_button__33KvH"};